import { Pipe, PipeTransform } from '@angular/core';
import { ICustomer } from '../model/customer';

@Pipe({name: 'customerName'})
export class CustomerNamePipe implements PipeTransform {
  public transform(customer: ICustomer): string {
    return customer ? customer.company || customer.firstname + ' ' + customer.lastname : '';
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/pipe/customer-name.pipe.ts